module.exports = __webpack_public_path__ + "img/mena-hurma.babaa210.svg";